import classNames from "classnames";
import { FC, HTMLAttributes } from "react";

type FormColProps = HTMLAttributes<HTMLDivElement>

export const FormCol: FC<FormColProps> = ({ className, children, ...props }) => {
    return (
        <div className={classNames("flex flex-col gap-4", className)} {...props}>
            {children}
        </div>
    );
};